import { IMPORT_DOCUMENT_KEYS_FORMAT_MAP } from '../../../constants/importDocuments';

function formatSnakeCasedString(str) {
  // Split the string on underscores
  const words = str.split('_');

  // Convert each word to lowercase and capitalize the first letter of the first word
  const formattedWords = words.map((word, index) => {
    // eslint-disable-next-line no-param-reassign
    word = word.toLowerCase();
    if (index === 0 && word.length > 0) {
      return word[0].toUpperCase() + word.slice(1);
    }
    return word;
  });

  // Join the words with a space and return the result
  return formattedWords.join(' ');
}

export default function formatKey(key) {
  const formattedKey =
    IMPORT_DOCUMENT_KEYS_FORMAT_MAP[key] || formatSnakeCasedString(key);

  return formattedKey;
}
